export default "__VITE_ASSET__Biw2D4xD__"